import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, LinearProgress, Typography } from '@mui/material';
import './scss/menu-library-flow-dialogs.style.scss';

/** 流程进度弹窗 props（上传中 / 菜品添加中等） */
export type MenuLibraryFlowProgressDialogProps = {
    /** 是否打开 */
    open: boolean;
    /** 标题文案 */
    title: string;
    /** 中部图标（云上传 / 云下载等） */
    icon: React.ReactNode;
    /** 进度条无障碍标签，默认用 title */
    progressAriaLabel?: string;
};

/**
 * 云端流程「进行中」浮层：标题 + 图标 + 假进度条（Figma `9786:51121` 壳）。
 * 接口无真实百分比时，打开期间推进至约 92%，关闭后归零。
 */
const MenuLibraryFlowProgressDialog: React.FC<MenuLibraryFlowProgressDialogProps> = ({
    open,
    title,
    icon,
    progressAriaLabel,
}) => {
    // 假进度 0–92
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (!open) {
            setProgress(0);
            return undefined;
        }
        setProgress(8);
        // 定时推进至 92%，完成后由关闭态归零
        const timer = window.setInterval(() => {
            setProgress((prev) => Math.min(prev + Math.random() * 12, 92));
        }, 180);
        return () => window.clearInterval(timer);
    }, [open]);

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            onClose={() => undefined}
            maxWidth={false}
            className="menu-library-flow-progress-dialog"
            PaperProps={{ className: 'menu-library-flow-progress-dialog__paper' }}
        >
            <DialogContent className="menu-library-flow-progress-dialog__content">
                <Typography variant="h3" component="h2" className="menu-library-flow-progress-dialog__title">
                    {title}
                </Typography>
                <span className="menu-library-flow-progress-dialog__icon" aria-hidden>
                    {icon}
                </span>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    className="menu-library-flow-progress-dialog__progress"
                    aria-label={progressAriaLabel ?? title}
                />
            </DialogContent>
        </Dialog>
    );
};

export default MenuLibraryFlowProgressDialog;
